// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file bffuser/v1/user_directory_service.proto (package bffuser.v1, syntax proto3)
/* eslint-disable */

import { UserDirectoryService } from "./user_directory_service_pb";

/**
 * ListMembers returns all members of the caller's organisation.
 *
 * @generated from rpc bffuser.v1.UserDirectoryService.ListMembers
 */
export const listMembers = UserDirectoryService.method.listMembers;
